












































import { defineComponent, computed, onMounted, watch } from "@vue/composition-api";
import { LMap, LTileLayer, LMarker, LIcon, LPopup } from "vue2-leaflet";
import VMarkerCluster from "vue2-leaflet-markercluster";
import useFetcher from "@/ts/functions/composition/useFetcher";
import PlaceModel from "@/ts/models/placeClass";
import L from "leaflet";
import "leaflet.markercluster";
import PlaceCard from "@c/molecules/place/PlaceCard.vue";

interface Marker{
  mapObject:{
    getLatLng:()=>Array<number>, 
    openPopup:()=>void,

  }
}

interface Map{
  mapObject:{
    setView:(lgtLat:Array<number>, zoom?:number)=>void
  }
}

export default defineComponent({
  name: "Map",

  components: {
    PlaceCard,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    VMarkerCluster
  },

  setup(props, {refs, root}) {
    var { entity: places, loading } = useFetcher("place/GET_ALL_PLACES");

    var displayed_places = computed(() => {
      var adresses: Array<PlaceModel> = [];
      if (places.value) {
        places.value.forEach((place: PlaceModel) => {
          if (place.location) {
            adresses.push(place);
          }
        });
      }
      return adresses;
    });

    watch(() => places.value, (newPlaces:any) => {

      if(root.$route.params.focusId &&
      root.$route.params.focusType){
        root.$nextTick(() => {
          const markerName = 'marker_'+root.$route.params.focusId
          if(newPlaces.length &&
          refs[markerName]){
            var marker = (refs[markerName] as Array<Vue & Marker>)[0].mapObject
            var map = (refs.refMap as Vue & Map).mapObject
            map.setView(marker.getLatLng(), 13)
            setTimeout(()=>{
              marker.openPopup()
            },300)
          }
        });
      }
    });

    return {
      places,
      loading,
      displayed_places
    };
  }
});
